import React, { useState } from "react";
import Model from "@tripian/model";
import useTranslate from "../../hooks/useTranslate";
import { DeleteUser, DeleteUserSuccess } from "@tripian/react";
import { useNavigate } from "react-router-dom";
import { LANDING } from "../../constants/ROUTER_PATH_TITLE";
import { api } from "@tripian/core";
import useAuth from "../../hooks/useAuth";
import { removeLocalStorageToken } from "../../App/AppWrapper/localStorages";
import { useDispatch } from "react-redux";
import { saveNotification } from "../../redux/action/user";

const DeleteUserPage = () => {
  const { logout } = useAuth();
  const { onSelectedLangCode } = useTranslate();

  const [success, setSuccess] = useState<boolean>(false);

  const dispatch = useDispatch();

  const { t } = useTranslate();

  const navigate = useNavigate();

  const callbackSuccessLogin = () => {
    setSuccess(true);
  };

  const userDeleteFetch = async () => {
    try {
      return await api.userDelete();
    } catch (userDeleteError: any) {
      dispatch(
        saveNotification(
          Model.NOTIFICATION_TYPE.ERROR,
          "userDelete",
          t("user.deleteUser.deleteBtn"),
          userDeleteError
        )
      );
      throw userDeleteError;
    }
  };

  return (
    <div className="full-center">
      {success ? (
        <DeleteUserSuccess
          goRegister={() => {
            removeLocalStorageToken();
            logout();
            onSelectedLangCode("en");
            if (window.tconfig.SHOW_LANDING_PAGE) navigate(LANDING.PATH);
            else navigate(LANDING.PATH);
          }}
          t={t}
        />
      ) : (
        <DeleteUser
          userDeleteCallback={userDeleteFetch}
          success={callbackSuccessLogin}
          goBack={() => {
            navigate(-1);
          }}
          t={t}
        />
      )}
    </div>
  );
};

export default DeleteUserPage;
